import { Component, OnInit } from '@angular/core';

import { Locale } from './../../service/locale.service';

@Component({
  selector: 'app-plswait',
  templateUrl: './plswait.component.html',
  styleUrls: ['./plswait.component.css']
})
export class PlswaitComponent  {

    public visible = false;
    public visibleAnimate = false;

    constructor(private locale: Locale) {}

    public show() {
        this.visible = true;
        setTimeout(() => this.visibleAnimate = true, 100);
    }

    public hide() {
        this.visible = false;
        setTimeout(() => this.visibleAnimate = false, 100);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/MODAL-plswait/plswait.component.ts